module.exports = __webpack_public_path__ + "img/completed.48b22cd2.svg";